import { ordinal } from "../infra/utils";
export let BillingDayOfMonthType = /*#__PURE__*/function (BillingDayOfMonthType) {
  BillingDayOfMonthType["LastDayOfMonth"] = "lastDayOfMonth";
  BillingDayOfMonthType["DayOfMonth"] = "dayOfMonth";
  return BillingDayOfMonthType;
}({});
export class BillingDayOfMonthModel {
  static make(dayOfMonth) {
    if (dayOfMonth instanceof BillingDayOfMonthModel) {
      return dayOfMonth;
    } else if (typeof dayOfMonth === 'number') {
      return new BillingDayOfMonthNotLastModel(makeBillingDayOfMonthNotLast(dayOfMonth));
    } else if (!dayOfMonth || dayOfMonth === 'last') {
      return new BillingDayOfMonthLastModel(makeBillingDayOfMonthLast());
    } else if (dayOfMonth.type === BillingDayOfMonthType.LastDayOfMonth) {
      return new BillingDayOfMonthLastModel(dayOfMonth);
    } else {
      return new BillingDayOfMonthNotLastModel(dayOfMonth);
    }
  }
  static isEqual(dayOfMonth1, dayOfMonth2) {
    if (!dayOfMonth1) {
      return !dayOfMonth2;
    } else if (!dayOfMonth2) {
      return false;
    } else if (dayOfMonth1.isLast()) {
      return dayOfMonth2.isLast();
    } else {
      return !dayOfMonth2.isLast() && dayOfMonth1.day === dayOfMonth2.day;
    }
  }
  constructor(dayOfMonth) {
    this.dayOfMonth = dayOfMonth;
  }
  isLast() {
    return this.isLastDayOfMonth(this.dayOfMonth);
  }
  toJSON() {
    return this.dayOfMonth;
  }
  toDBType() {
    return this.isLastDayOfMonth(this.dayOfMonth) ? {
      type: this.dayOfMonth.type
    } : {
      type: this.dayOfMonth.type,
      dayOfMonth: {
        day: this.dayOfMonth.day
      }
    };
  }
  toNormalizedDayOfMonth() {
    return this.isLastDayOfMonth(this.dayOfMonth) ? 'last' : this.dayOfMonth.day;
  }
  formatDay() {
    let lastDayStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'last';
    return this.isLastDayOfMonth(this.dayOfMonth) ? lastDayStr : ordinal(this.dayOfMonth.day);
  }
  isLastDayOfMonth(dayOfMonth) {
    return dayOfMonth.type === BillingDayOfMonthType.LastDayOfMonth;
  }
}
class BillingDayOfMonthLastModel extends BillingDayOfMonthModel {
  constructor(dayOfMonth) {
    super(dayOfMonth);
  }
}
class BillingDayOfMonthNotLastModel extends BillingDayOfMonthModel {
  constructor(dayOfMonth) {
    super(dayOfMonth);
    this.day = dayOfMonth.day;
  }
}
export function makeBillingDayOfMonthLast() {
  return {
    type: BillingDayOfMonthType.LastDayOfMonth
  };
}
export function makeBillingDayOfMonthNotLast(day) {
  return {
    type: BillingDayOfMonthType.DayOfMonth,
    day
  };
}